/**
 * Copyright (c) 2025, CYBRA Corp. All rights reserved.
 */
export class ApiTokenHeader {
  id: number;
  apiToken: string;
  userId: number;
  createdBy: number;
  enabled: boolean;
  description?: string;
  createdTs: string;
  modifiedTs?: string;

   /** Optional property for UI selection checkbox */
  selected?: boolean;


}